const routes = [
    {
        path: "/advising",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "advisorapproval_index"
        }
    }
];

export default routes;
